module.exports = __webpack_public_path__ + "static/media/plafond.a9df74d5.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plafond.PNG
// module id = 1099
// module chunks = 0